import { Component, OnDestroy, input, output, signal, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ServerService } from 'src/app/services/server.service';
import { Server } from 'src/app/models/server';
import { LTDropDownComponent } from '../lt-dropdown/lt-dropdown.component';

@Component({
  selector: 'app-server-dropdown-view',
  imports: [LTDropDownComponent],
  template: `
    @if(hasItems())
      {
        <app-lt-dropdown
            [label]="'Select Server'"
            [data]="allServers()"
            [textField]="'description'"
            [valueField]="'serverId'"
            [value]="overrideId()"
            [displayWithFn]="displayServer"
            (selectionChange)="selectServer($event)">
        </app-lt-dropdown>
      }
  `,
  styles: '',
})
export class ServerDropdownViewComponent implements OnDestroy, OnInit {
  private readonly destroyed$ = new Subject<void>();
  label = input<string>('Servers');
  serverList = input.required<Server[]>();
  //itemSelected = output<Server>();
  loadingFailed = output<void>();
  serverSelectEvent = output<string>();
  overrideId = input<string | null>(null);

  hasItems = signal<boolean>(false);
  allServers = signal<Server[] | []>([]);

  constructor(protected serverService: ServerService) {

   }

  ngOnInit(): void {
    this.hasItems.set(false);
    if (this.serverList() != null && this.serverList()?.length > 0) {
      this.allServers.set(this.serverList());
      this.hasItems.set(true);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(undefined);
    this.destroyed$.complete();
  }

  getServers(): void {
    this.hasItems.set(false);
    if (this.serverList() != null && this.serverList()?.length > 0) {
      this.allServers.set(this.serverList());
      this.hasItems.set(true);
    }
    else {
      this.serverService.getAllServersInformation()
        .pipe(takeUntil(this.destroyed$))
        .subscribe((data) => {
          this.allServers.set(data.sort((s1, s2) => Number.parseInt(s1.serverId) - Number.parseInt(s2.serverId)));
          this.hasItems.set(true);
        });
    }
  }

  selectServer(serverId: string): void {
    if(!this.overrideId() || serverId !== this.overrideId()) {
    this.serverSelectEvent.emit(serverId);
    }
  }

  displayServer(server: Server): string {
    if (server.serverId == '0') {
      return 'Remove from servers';
    }
    else {
      return `App ${server.serverId} - Count: ${server.integrationCount}`;
    }
  }
}
